// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o4LScjZLqME7Fv2f98sZ{flex-direction:column;gap:4px;display:flex}._bfkMGiDpseNv6cLeiA4{align-items:flex-start;padding-left:7px}._bfkMGiDpseNv6cLeiA4.oOrS03jLE2coGeJNReZL{background-color:transparent}._bfkMGiDpseNv6cLeiA4:hover{background:var(--background-neutral-subtle);border-radius:6px}._bfkMGiDpseNv6cLeiA4.uPoLsyRCWIAHIIQFP_EO{background:0 0}.RpgeWKG5x80UlcwOU4Bn{gap:12px;padding:12px}.PFCxXFaJIzsNmrWyg6uc{padding:2px}.E6oheQ3HkYMkEE9eyStw{padding:10px}.wwcT7QLznsbU3Yxk2eCO{color:var(--content-primary-primary);padding:10px 8px 4px}.jJGCMu_gyXMHIZJRa8DZ{color:var(--gray-60);justify-content:center;align-items:center;height:40px;padding:8px 0;font-size:12px;font-weight:400;line-height:15px;display:flex}.JPoKBdrqVQsXq1UQlVI2{margin-right:-1px}.UtQlAl1shcSRpijcm7r7{justify-content:space-between;align-items:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customLabel": `o4LScjZLqME7Fv2f98sZ`,
	"bookingRadio": `_bfkMGiDpseNv6cLeiA4`,
	"checked": `oOrS03jLE2coGeJNReZL`,
	"disabled": `uPoLsyRCWIAHIIQFP_EO`,
	"selectLabel": `RpgeWKG5x80UlcwOU4Bn`,
	"loaderTrigger": `PFCxXFaJIzsNmrWyg6uc`,
	"dropdownLoader": `E6oheQ3HkYMkEE9eyStw`,
	"wrapper": `wwcT7QLznsbU3Yxk2eCO`,
	"noResult": `jJGCMu_gyXMHIZJRa8DZ`,
	"labelRight": `JPoKBdrqVQsXq1UQlVI2`,
	"schedulingTitle": `UtQlAl1shcSRpijcm7r7`
};
export default ___CSS_LOADER_EXPORT___;
